import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const dateTimeFieldDefaultVariants = {
  "error": false,
  "disabled": false,
  "open": false,
  "editing": false,
  "labelHidden": false
}
const dateTimeFieldCompoundVariants = []

const dateTimeFieldSlotNames = [
  [
    "root",
    "DateTimeField__root"
  ],
  [
    "label",
    "DateTimeField__label"
  ],
  [
    "field",
    "DateTimeField__field"
  ],
  [
    "resting",
    "DateTimeField__resting"
  ],
  [
    "segments",
    "DateTimeField__segments"
  ],
  [
    "segment",
    "DateTimeField__segment"
  ],
  [
    "message",
    "DateTimeField__message"
  ],
  [
    "popover",
    "DateTimeField__popover"
  ],
  [
    "list",
    "DateTimeField__list"
  ],
  [
    "option",
    "DateTimeField__option"
  ]
]
const dateTimeFieldSlotFns = /* @__PURE__ */ dateTimeFieldSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, dateTimeFieldDefaultVariants, getSlotCompoundVariant(dateTimeFieldCompoundVariants, slotName))])

const dateTimeFieldFn = memo((props = {}) => {
  return Object.fromEntries(dateTimeFieldSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const dateTimeFieldVariantKeys = [
  "labelHidden",
  "error",
  "disabled",
  "open",
  "editing"
]
const getVariantProps = (variants) => ({ ...dateTimeFieldDefaultVariants, ...compact(variants) })

export const dateTimeField = /* @__PURE__ */ Object.assign(dateTimeFieldFn, {
  __recipe__: false,
  __name__: 'dateTimeField',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: dateTimeFieldVariantKeys,
  variantMap: {
  "labelHidden": [
    "true"
  ],
  "error": [
    "true"
  ],
  "disabled": [
    "true"
  ],
  "open": [
    "true"
  ],
  "editing": [
    "true"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, dateTimeFieldVariantKeys)
  },
  getVariantProps
})